import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';
import { Router } from '@angular/router';

import { SessionService } from '../api/session.service';
import { UserService } from '../api/resources/user.service';
import { PasswordService } from '../api/resources/password.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.less'],
  providers: [SessionService, UserService, PasswordService]
})
export class SettingsComponent implements OnInit {
  oldPassword: string;
  newPassword: string;
  repeatPassword: string;
  loading: boolean = false;
  changeError: boolean = false;
  changeSuccess: boolean = false;
  matchError: boolean = false;
  validationError: boolean = false;
  oldPasswordError: boolean = false;
  oldPasswordValid: boolean = false;
  nameChange: boolean = false;
  passwordChange: boolean = false;
  user: any = {};
  message: string;

  constructor(private sessionService: SessionService,
              private userService: UserService,
              private passwordService: PasswordService,
              private router: Router) { }

  ngOnInit() {
   this.getUser();
  }

  getUser() {
    const user_id = this.sessionService._id;
    this.userService.detail(user_id)
      .subscribe(res => {
        this.user = res;
      });
  }

  validate($event) {
    this.validationError = !$event;
  }

  match($event) {
    this.matchError = !$event;
    this.passwordChange = !this.validationError && !this.matchError;
  }

  newName() {
    if (this.user.name.length > 0) {
      this.nameChange = true;
    }
  }

  saveProfileSettings() {
    this.changeError = false;
    this.loading = true;
    if (this.nameChange) {
      this.userService.update(this.user._id, this.user)
       .subscribe(res => {
         this.loading = false;
         this.changeError = false;
         this.changeSuccess = true;
       }, err => {
         this.loading = false;
         this.changeError = true;
       });
    }
    if (this.passwordChange) {
      this.passwordService.changePassword(this.oldPassword, this.newPassword)
        .subscribe((res: Response) => {
          this.loading = false;
          this.changeError = false;
          this.changeSuccess = true;
          this.oldPasswordError = false;
          this.oldPasswordValid = true;
        }, (err: any) => {
          this.loading = false;
          this.message = err.json();
          if (this.message === 'old password does not match') {
            this.oldPasswordError = true;
            this.oldPasswordValid = false;
          } else {
            this.message = 'Sorry, an unknown error has occurred, please check your internet connection and try again.'
            this.changeError = true;
          }
        });
    }
  }

  cancel() {
    this.getUser();
    this.changeSuccess = false;
    this.oldPassword = '';
    this.newPassword = '';
    this.repeatPassword = '';
    this.loading = false;
    this.changeError = false;
    this.changeSuccess = false;
    this.matchError = false;
    this.validationError = false;
    this.oldPasswordError = false;
    this.oldPasswordValid = false;
    this.nameChange = false;
    this.passwordChange = false;
  }

  logout() {
    this.sessionService.destroy();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts